module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-1-870820a49bce7e4839d819917986dd5c.jpg";